// extracted by mini-css-extract-plugin
export default {"grid":"NftGridFullWidth_grid__8bhgj"};